import k from '../constants/k'
import { w } from '../state/globals'
import { potions } from '../constants/potions'
import book from '../components/book'
import inventory from '../components/inventory'
import { mouse } from '../components/mouse'

k.loadSprite('book-menu', 'sprites/ui/book-menu.png')
k.loadSprite('book-page', 'sprites/potions/pages.png', {
  sliceX: 9,
  sliceY: 2,
  anims: {
    animalWhispers: 0,
    dreams: 1,
    friendship: 2,
    glow: 3,
    health: 4,
    love: 5,
    luck: 6,
    secrets: 7,
    shadows: 8,
    animalWhispersUnfound: 9,
    dreamsUnfound: 10,
    friendshipUnfound: 11,
    glowUnfound: 12,
    healthUnfound: 13,
    loveUnfound: 14,
    luckUnfound: 15,
    secretsUnfound: 16,
    shadowsUnfound: 17
  }
})
k.loadSprite('potion-button', 'sprites/ui/potion-buttons.png', {
  sliceX: 2,
  sliceY: 2,
  anims: {
    selected: 0,
    default: 1,
    foundSelected: 2,
    found: 3
  }
})

const bookMenu = k.make([k.sprite('book-menu')])
const page = bookMenu.add([k.sprite('book-page'), k.pos(32, 34)])
page.play('animalWhispersUnfound')

let selectedSlot = null
let selectedIndex = 0

export default () => {
  k.add(bookMenu)
  const { cursor } = mouse()
  inventory(cursor)
  book(cursor)

  potions.forEach((potion, index) => {
    const potionSlot = bookMenu.add([
      k.sprite('potion-button'),
      k.pos(w / 2 + 13 + (index % 3) * 17, 42 + Math.floor(index / 3) * 17),
      k.anchor('center'),
      k.area(),
      potion.name
    ])

    if (index === selectedIndex) {
      if (potion.found) potionSlot.play('foundSelected')
      else potionSlot.play('selected')
      selectedSlot = potionSlot
    } else {
      if (potion.found) potionSlot.play('found')
      else potionSlot.play('default')
    }

    potionSlot.onHover(() => {
      cursor.play('pointer')
    })
    potionSlot.onHoverEnd(() => {
      cursor.play('default')
    })

    potionSlot.onClick(() => {
      k.play('pop')
      if (selectedSlot) {
        if (potions[selectedIndex].found) selectedSlot.play('found')
        else selectedSlot.play('default')
      }

      if (potion.found) potionSlot.play('foundSelected')
      else potionSlot.play('selected')
      selectedSlot = potionSlot

      if (potion.found) page.play(potions[index].name)
      else page.play(`${potions[index].name}Unfound`)
      selectedIndex = index
    })
  })
}
